module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-pers",
    attrs: {
      "id": "pers-tab2",
      "name": "hrms32e-tab2"
    }
  }, [_c('hrms32e-tab2-tab1', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subPage === 1),
      expression: "subPage === 1"
    }],
    staticClass: "animate-option animated",
    class: {
      'slideInLeft': _vm.swipeRight, 'slideInRight': _vm.swipeLeft
    },
    attrs: {
      "nowLang": _vm.nowLang,
      "allLang": _vm.allLang,
      "indexSelected": _vm.indexSelected,
      "validateStaappr": _vm.validateStaappr,
      "labels": _vm.labels,
      "labelsButton": _vm.labelsButton,
      "dropdowns": _vm.dropdowns,
      "detail": _vm.detail.tab1,
      "pcDisp": _vm.pcDisp,
      "togglePage": _vm.togglePage,
      "toggleSubPage": _vm.toggleSubPage,
      "triggerSubButton": _vm.triggerSubButton,
      "postDetail2Tab1Save": _vm.postDetail2Tab1Save,
      "searchDetail": _vm.searchDetail,
      "searchIndex": _vm.searchIndex
    }
  }), _vm._v(" "), _c('hrms32e-tab2-tab2', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subPage === 2),
      expression: "subPage === 2"
    }],
    staticClass: "animate-option animated",
    class: {
      'slideInLeft': _vm.swipeRight, 'slideInRight': _vm.swipeLeft
    },
    attrs: {
      "nowLang": _vm.nowLang,
      "indexSelected": _vm.indexSelected,
      "validateStaappr": _vm.validateStaappr,
      "labels": _vm.labels,
      "labelsButton": _vm.labelsButton,
      "dropdowns": _vm.dropdowns,
      "detail": _vm.detail.tab2,
      "pcDisp": _vm.pcDisp,
      "togglePage": _vm.togglePage,
      "toggleSubPage": _vm.toggleSubPage,
      "triggerSubButton": _vm.triggerSubButton,
      "postDetail2Tab2Save": _vm.postDetail2Tab2Save,
      "searchDetail": _vm.searchDetail,
      "searchIndex": _vm.searchIndex
    }
  }), _vm._v(" "), _c('hrms32e-tab2-tab3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subPage === 3),
      expression: "subPage === 3"
    }],
    staticClass: "animate-option animated",
    class: {
      'slideInLeft': _vm.swipeRight, 'slideInRight': _vm.swipeLeft
    },
    attrs: {
      "nowLang": _vm.nowLang,
      "indexSelected": _vm.indexSelected,
      "validateStaappr": _vm.validateStaappr,
      "labels": _vm.labels,
      "labelsButton": _vm.labelsButton,
      "dropdowns": _vm.dropdowns,
      "detail": _vm.detail.tab3,
      "pcDisp": _vm.pcDisp,
      "togglePage": _vm.togglePage,
      "toggleSubPage": _vm.toggleSubPage,
      "triggerSubButton": _vm.triggerSubButton,
      "postDetail2Tab3Save": _vm.postDetail2Tab3Save,
      "searchDetail": _vm.searchDetail,
      "searchIndex": _vm.searchIndex
    }
  }), _vm._v(" "), _c('hrms32e-tab2-tab4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subPage === 4),
      expression: "subPage === 4"
    }],
    staticClass: "animate-option animated",
    class: {
      'slideInLeft': _vm.swipeRight, 'slideInRight': _vm.swipeLeft
    },
    attrs: {
      "nowLang": _vm.nowLang,
      "indexSelected": _vm.indexSelected,
      "validateStaappr": _vm.validateStaappr,
      "labels": _vm.labels,
      "labelsButton": _vm.labelsButton,
      "dropdowns": _vm.dropdowns,
      "detail": _vm.detail.tab4,
      "pcDisp": _vm.pcDisp,
      "togglePage": _vm.togglePage,
      "toggleSubPage": _vm.toggleSubPage,
      "triggerSubButton": _vm.triggerSubButton,
      "postDetail2Tab4Save": _vm.postDetail2Tab4Save,
      "searchDetail": _vm.searchDetail,
      "searchIndex": _vm.searchIndex
    }
  }), _vm._v(" "), _c('hrms32e-tab2-tab5', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subPage === 5),
      expression: "subPage === 5"
    }],
    staticClass: "animate-option animated",
    class: {
      'slideInLeft': _vm.swipeRight, 'slideInRight': _vm.swipeLeft
    },
    attrs: {
      "nowLang": _vm.nowLang,
      "indexSelected": _vm.indexSelected,
      "validateStaappr": _vm.validateStaappr,
      "labels": _vm.labels,
      "labelsButton": _vm.labelsButton,
      "dropdowns": _vm.dropdowns,
      "detail": _vm.detail.tab5,
      "pcDisp": _vm.pcDisp,
      "togglePage": _vm.togglePage,
      "toggleSubPage": _vm.toggleSubPage,
      "triggerSubButton": _vm.triggerSubButton,
      "postDetail2Tab5Save": _vm.postDetail2Tab5Save,
      "searchDetail": _vm.searchDetail,
      "searchIndex": _vm.searchIndex
    }
  }), _vm._v(" "), _c('hrms32e-tab2-tab6', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subPage === 6),
      expression: "subPage === 6"
    }],
    staticClass: "animate-option animated",
    class: {
      'slideInLeft': _vm.swipeRight, 'slideInRight': _vm.swipeLeft
    },
    attrs: {
      "nowLang": _vm.nowLang,
      "indexSelected": _vm.indexSelected,
      "validateStaappr": _vm.validateStaappr,
      "labels": _vm.labels,
      "labelsButton": _vm.labelsButton,
      "detail": _vm.detail.tab6,
      "pcDisp": _vm.pcDisp,
      "togglePage": _vm.togglePage,
      "toggleSubPage": _vm.toggleSubPage,
      "triggerSubButton": _vm.triggerSubButton,
      "postDetail2Tab6Save": _vm.postDetail2Tab6Save,
      "searchDetail": _vm.searchDetail,
      "searchIndex": _vm.searchIndex
    }
  }), _vm._v(" "), _c('hrms32e-tab2-tab7', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.subPage === 7),
      expression: "subPage === 7"
    }],
    staticClass: "animate-option animated",
    class: {
      'slideInLeft': _vm.swipeRight, 'slideInRight': _vm.swipeLeft
    },
    attrs: {
      "nowLang": _vm.nowLang,
      "indexSelected": _vm.indexSelected,
      "validateStaappr": _vm.validateStaappr,
      "detail2Tab7Table": _vm.detail2Tab7Table,
      "labels": _vm.labels,
      "labelsButton": _vm.labelsButton,
      "deleteDocuments": _vm.deleteDocuments,
      "dropdowns": _vm.dropdowns,
      "detail": _vm.detail.tab7,
      "pcDisp": _vm.pcDisp,
      "togglePage": _vm.togglePage,
      "toggleSubPage": _vm.toggleSubPage,
      "triggerSubButton": _vm.triggerSubButton,
      "postDetail2Tab7Save": _vm.postDetail2Tab7Save,
      "searchDetail": _vm.searchDetail,
      "searchIndex": _vm.searchIndex,
      "personalDataActive": _vm.personalDataActive
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-494cf7ad!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms32e/tab2.vue
// module id = 3733
// module chunks = 1